import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Controls from "../../../../components/form/controls/Controls";
import { NotifyConfirm } from "../../../../components/notify/Notify";
import { updateTTSSlot } from "../../../../apis/TTS/slot.api";

const ContextPropInput = ({ slot, updateProps }) => {
  let { props } = slot;
  const [propList, setPropList] = useState([]);

  useEffect(() => {
    setPropList([...JSON.parse(props.length ? props : "[]")]);
  }, [props]);

  const handlePropChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...propList];
    list[index][name] = value;
    setPropList(list);
    updateProps(JSON.stringify(list));
  };

  const handlePropRemove = (index) => {
    NotifyConfirm("warning", "Are you delete it?", (result) => {
      if (result.isConfirmed) {
        const list = [...propList];
        list.splice(index, 1);
        setPropList(list);
        updateProps(JSON.stringify(list));

        // call api update if not new slot
        if (slot?.id) {
          updateTTSSlot(slot.id, { ...slot, props: JSON.stringify(list) });
        }
      }
    });
  };

  const handlePropAdd = () => {
    setPropList([...propList, { name: "" }]);
  };
  return (
    <div style={{ width: "88%" }} autoComplete="off">
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {`${slot?.name} properties`}
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h5>prop config</h5>
              <Controls.Button
                variant="outlined"
                text="Add Prop"
                startIcon={<AddIcon />}
                onClick={handlePropAdd}
              />
            </div>
            {propList.map((prop, index) => (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Controls.Input
                  name="name"
                  value={prop.name}
                  label={`prop ${index + 1}`}
                  type="text"
                  onChange={(e) => handlePropChange(e, index)}
                />
                <Controls.Button
                  variant="outlined"
                  text="remove"
                  color="error"
                  onClick={() => handlePropRemove(index)}
                />
              </div>
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ContextPropInput;
